
<template>
    <v-dialog v-model="showDialog" persistent max-width="600px">
        <v-card>
            <v-card-title>
                Warning!!
            </v-card-title>
            <v-card-text>
                <v-container fluid>
                    <v-layout wrap>
                        <v-flex>
                            Soll der Datensatz tatsächlich gelöscht werden?
                        </v-flex>
                    </v-layout>
                  </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                 <v-btn icon v-on:click="commitDelete(true)">
                    <v-icon x-large class="green--text">done</v-icon>
                </v-btn>                                  
                <v-btn icon v-on:click="commitDelete(false)">
                    <v-icon x-large class="red--text">close</v-icon>
                </v-btn>

            </v-card-actions>
        </v-card>
        
    </v-dialog>
</template>

<script>
export default {
    props:['showDialog'],
    
    
    
    methods: {
                
        commitDelete: function(s) {
            this.$emit('update:showDialog',false )
            this.$emit('committed', s)            
        }
       
    }    
}
</script>

<style>
    


</style>


// WEBPACK FOOTER //
// deleteModal.vue?109a4a1a